import React from 'react';
import { connect } from 'react-redux'
import {
  IonRefresher,
  IonRefresherContent,
  withIonLifeCycle,
  IonGrid,
  IonRow,
  IonCol,
  IonItem,
  IonList,
  IonContent,
  IonHeader, IonPage, IonTitle, IonToolbar,
  IonIcon,
  IonLabel,
  IonButton,
  IonPopover,
  IonButtons,
  IonMenuButton, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent
} from '@ionic/react';
import {fileTrayFullOutline,walletOutline , podiumOutline,cashOutline , ticketOutline, ellipsisVerticalOutline, serverOutline, cart, checkmarkCircle, closeCircle, cubeOutline, ban } from 'ionicons/icons';
import './Home.css';
import PosActions from '../../actions/PosActions';
import MenuPrincipal from '../../components/menu/MenuPrincipal';
import { getLoginApp, getToken, getPermissions, getNewLogin, getEnabledModules } from '../../utils/functions';
import { initdb } from "../../data_base_local/dataservice";
import { Capacitor } from '@capacitor/core';
import moment from 'moment';
import UtilActions from '../../actions/UtilActions';

import {
  queryAllLocations,
  createLocationTest,
  queryAllPermisions,
  queryAllConfiguration,
  createConfiguration,
  getConfigurationById,
  updateConfigurationById,
  createPermission,
  createActivitie
} from "../../data_base_local/dataservice";

interface IProps {
  get_: any;
  validate_permission_: any;
}

interface IState {
  dataPermissions: any;
  is_valid: any;
  data_login: any;
  permissionsUser: any;
  enabled_modules: any;
  data_default: any;
}

class Home extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props)
    this.state = {
      dataPermissions: props.dataPermissions,
      is_valid: props.is_valid,
      data_login: props.data_login,
      permissionsUser: props.permissionsUser,
      enabled_modules: props.enabled_modules,
      data_default: props.data_default
    }

  }

  ionViewWillEnter() {
    this.componentDidMount();
  }

  UNSAFE_componentWillReceiveProps(nextProps: any) {
    this.setState({
      data_default: nextProps.data.data_default,
    });
    if (nextProps.data.data_default && nextProps.data.data_default.enabled_modules != this.state.enabled_modules) {
      this.ValidatePermissionAll();
    }

  }
  async componentDidMount() {

    this.props.get_({
      typeOption: 'get_data_default',
      user_id: getLoginApp().id,
    }, "api/get_data_default");

    this.props.get_({}, "api/get_pro");
    let data_login = getLoginApp();
    let token = getToken();
    let new_login = getNewLogin();

    initdb().catch(() => console.log("error sql"));

    if (Capacitor.isNativePlatform()) {

      let config = await getConfigurationById(1).then();
      if (config && config.values.length > 0) {
        let id_config = config.values[0].id;
        await updateConfigurationById(id_config, {
          token: getToken(),
          data_login: JSON.stringify(getLoginApp())
        }).then();

        //permisions
        let permisions = await getConfigurationById(2).then();
        if (permisions && permisions.values.length > 0) {
          let id_permisions = permisions.values[0].id;
          await updateConfigurationById(id_permisions, {
            token: '-',
            data_login: JSON.stringify(getPermissions())
          }).then();
        } else {
          let data = {
            token: '-',
            data_login: JSON.stringify(getPermissions())
          }
          await createConfiguration(data).then();
        }
      } else {
        let data = {
          token: token,
          data_login: JSON.stringify(data_login)
        }
        await createConfiguration(data).then();
        config = await getConfigurationById(1).then();
        //permisions
        let permisions = await getConfigurationById(2).then();
        if (permisions && permisions.values.length > 0) {
          let id_permisions = permisions.values[0].id;
          await updateConfigurationById(id_permisions, {
            token: '-',
            data_login: JSON.stringify(getPermissions())
          }).then();
        } else {
          let data = {
            token: '-',
            data_login: JSON.stringify(getPermissions())
          }
          await createConfiguration(data).then();
        }
      }

      //insertar logueo
      if (new_login == 1) {
        if (data_login) {
          //insertar deslogueo
          await createActivitie({
            log_name: moment().format('YYYY-MM-DD HH:mm:ss'),
            description: 'login',
            date: moment().format('YYYY-MM-DD HH:mm:ss'),
            user_id: data_login.id
          }).then();
          localStorage.removeItem('ari_app_new_login');
        }
      }
      this.setState({
        data_login: data_login
      });

      this.ValidatePermission();
    } else {
      if (data_login) {
        this.setState({
          data_login: data_login
        });
      }
    }
    this.ValidatePermissionAll();

  }

  /*necesario para validar permisos*/

  async ValidatePermission() {
    let dataPermissions: any = await queryAllPermisions().then();
    let is_valid = true;
    if (dataPermissions && dataPermissions.values.length > 0) {
      dataPermissions.values.map((val: any, key: any) => {
        if (val.status !== 'active') {
          is_valid = false;
        }
      });
      this.setState({ dataPermissions: dataPermissions.values, is_valid: is_valid });

    } else {
      this.setState({ dataPermissions: [], is_valid: false });
    }


    //alert(is_valid);
  };

  /* fin necesario para validar permisos*/
  ValidatePermissionAll() {
    let permissionsUser_temp = getPermissions();
    let enabled_modules_temp = getEnabledModules();

    this.setState({
      permissionsUser: permissionsUser_temp,
      enabled_modules: enabled_modules_temp
    });

  }

  handleRefresh(event: any) {

    setTimeout(() => {
      event.detail.complete();
    }, 2000);
    window.location.reload();
  }
  render() {
    const { permissionsUser, dataPermissions, is_valid, data_login, enabled_modules } = this.state;
    console.log("permissionsUser", permissionsUser);
    // Validar si existe la propiedad access_own_sell_return en permissionsUser
    const hasAccessapp_view_customer_dues = permissionsUser && typeof permissionsUser === 'object'
      && !!permissionsUser.app_view_customer_dues;

    const hasAccessapp_view_pos = permissionsUser && typeof permissionsUser === 'object'
      && !!permissionsUser.app_view_pos;

    const hasAccessview_room_panel_module = permissionsUser && typeof permissionsUser === 'object'
      && !!permissionsUser.view_room_panel_module;

    const module_rooms_enabled = enabled_modules && typeof enabled_modules === 'object'
      && !!enabled_modules['rooms'];

    const hasAccessapp_view_products = permissionsUser && typeof permissionsUser === 'object'
      && !!permissionsUser.app_view_products;

    const hasAccessapp_view_expenses = permissionsUser && typeof permissionsUser === 'object'
      && !!permissionsUser.app_view_expenses;

    const hasAccessapp_view_purchase = permissionsUser && typeof permissionsUser === 'object'
      && !!permissionsUser.app_view_purchase;

    const hasAccessapp_view_registers = permissionsUser && typeof permissionsUser === 'object'
      && !!permissionsUser.app_view_registers;

    const hasAccessapp_view_all_suspend = permissionsUser && typeof permissionsUser === 'object'
      && !!permissionsUser.app_view_all_suspend;
    console.log("enabled_modules", enabled_modules, module_rooms_enabled);

    return (
      <>
        <MenuPrincipal />
        <IonPage id="main-content">
          <IonHeader className='ion-no-border'>
            <IonToolbar className='color-cyan'>
              <IonButtons slot="start" >
                <IonMenuButton autoHide={false}></IonMenuButton>
              </IonButtons>
              <IonTitle ></IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent fullscreen scrollEvents={true} className='background'>
            <IonRefresher slot="fixed" onIonRefresh={(e) => this.handleRefresh(e)}>
              <IonRefresherContent></IonRefresherContent>
            </IonRefresher>
            <IonCardHeader className='color-cyan border-bottom-left-radius border-bottom-left-radius border-bottom-right-radius height-100 text-center padding-top-0'>
              <IonCardTitle className='text-bold'>ARI-TECH</IonCardTitle>
            </IonCardHeader>
            <IonGrid className='padding-top--70 padding-left-20 padding-right-20'>
              <IonRow align-items-center>


                {
                  hasAccessapp_view_pos || (data_login && data_login.is_admin) ?

                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'#673ab7'}
                        className="height_card_buttom border-radius-shadow"
                        href="#/dashboard_pos/home"
                        style={{ borderRadius: "15px", background: "#673ab7", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={cart}
                            size="large"
                          />
                          <br />
                          <label>POS</label>
                        </div>
                      </IonButton>
                    </IonCol>
                    : null
                }

                {
                  hasAccessapp_view_customer_dues || (data_login && data_login.is_admin) ?

                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'#673ab7'}
                        className="height_card_buttom border-radius-shadow"
                        href="#/customer_dues"
                        style={{ borderRadius: "15px", background: "#28bb50", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={cashOutline}
                            size="large"
                          />
                          <br />
                          <label>CUENTAS X COBRAR</label>
                        </div>
                      </IonButton>
                    </IonCol>
                    : null
                }

                {
                  data_login && data_login.is_admin || (data_login && data_login.is_admin) ?
                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'#ffc509'}
                        className="height_card_buttom border-radius-shadow"
                        no-margin
                        href="#/backup"
                        style={{ borderRadius: "15px", background: "#ffc509", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={serverOutline}
                            size="large"
                          />
                          <br />
                          <label>BACKUP</label>
                        </div>
                      </IonButton>
                    </IonCol> : null
                }

                {
                  (enabled_modules && enabled_modules['rooms'] && hasAccessview_room_panel_module) || (data_login && data_login.is_admin && (enabled_modules && enabled_modules['rooms'])) ?
                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'#ffc509'}
                        className="height_card_buttom border-radius-shadow"
                        no-margin
                        href="#/rooms"
                        style={{ borderRadius: "15px", background: "#3F51B5", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={serverOutline}
                            size="large"
                          />
                          <br />
                          <label>HABITACIONES</label>
                        </div>
                      </IonButton>
                    </IonCol> : null
                }

                {

                  hasAccessapp_view_products || (data_login && data_login.is_admin) ?
                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'#ef4bbbff'}
                        className="height_card_buttom border-radius-shadow"
                        no-margin
                        href="#/dashboard_products/listProducts"
                        style={{ borderRadius: "15px", background: "#ef4bbbff", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={cubeOutline}
                            size="large"
                          />
                          <br />
                          <label>PRODUCTOS</label>
                        </div>
                      </IonButton>
                    </IonCol> : null


                }

                {

                  hasAccessapp_view_expenses || (data_login && data_login.is_admin) ?
                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'#ef4b4bff'}
                        className="height_card_buttom border-radius-shadow"
                        no-margin
                        href="#/dashboard_gastos/listGastos"
                        style={{ borderRadius: "15px", background: "#ef4b4bff", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={podiumOutline}
                            size="large"
                          />
                          <br />
                          <label>GASTOS</label>
                        </div>
                      </IonButton>
                    </IonCol> : null
                }

                {

                  hasAccessapp_view_purchase || (data_login && data_login.is_admin) ?
                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'#ef4b4bff'}
                        className="height_card_buttom border-radius-shadow"
                        no-margin
                        href="#/purchases"
                        style={{ borderRadius: "15px", background: "#0d66e3ff", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={walletOutline}
                            size="large"
                          />
                          <br />
                          <label>COMPRAS</label>
                        </div>
                      </IonButton>
                    </IonCol> : null
                }
                {
                  hasAccessapp_view_registers || (data_login && data_login.is_admin) ?
                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'#425a07ff'}
                        className="height_card_buttom border-radius-shadow"
                        no-margin
                        href="#/cajas"
                        style={{ borderRadius: "15px", background: "#425a07ff", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={fileTrayFullOutline}
                            size="large"
                          />
                          <br />
                          <label>CAJAS</label>
                        </div>
                      </IonButton>
                    </IonCol>
                    : null
                }

                {
                  hasAccessapp_view_all_suspend || (data_login && data_login.is_admin) ?
                    <IonCol col-6 size='6'>
                      <IonButton
                        color={'rgb(82, 14, 14)'}
                        className="height_card_buttom border-radius-shadow"
                        no-margin
                        href="#/orders_suspends"
                        style={{ borderRadius: "15px", background: "rgb(82, 14, 14)", borderColor: "#3f3d3d00" }}
                      >
                        <div>
                          <IonIcon
                            color="#ffffff"
                            slot="icon-only"
                            icon={ban}
                            size="large"
                          />
                          <br />
                          <label>SUSPENDIDAS</label>
                        </div>
                      </IonButton>
                    </IonCol>
                    : null
                }


              </IonRow>
            </IonGrid>
            <IonRow align-items-center>
              <IonCol col-12 size='12' className='text-center'>
                <IonCardTitle className='text-bold'>Permisos Necesarios</IonCardTitle>
              </IonCol>
              {
                !is_valid ?
                  <IonCol col-12 size='12' className='text-center'>
                    <IonCardTitle className='text-bold'>(*) Necesita tener todos los permisos activos para usar POS</IonCardTitle>
                  </IonCol> : null
              }
              <IonCol col-12 size='12' >
                <IonList inset={true}>
                  {dataPermissions && dataPermissions.length > 0 && dataPermissions.map((val: any, key: any) => {
                    return (
                      <IonItem key={key}>
                        <IonLabel>{
                          val.name == 'android.permission.WAKE_LOCK' ? 'Bloqueo de Activación' :
                            val.name == 'android.permission.FOREGROUND_SERVICE' ? 'Servicio en Segundo Plano' :
                              val.name == 'android.permission.ACCESS_COARSE_LOCATION' ? 'Ubicación' :
                                val.name == 'android.permission.ACCESS_FINE_LOCATION' ? 'Ubicación precisa' :
                                  val.name == 'android.permission.POST_NOTIFICATIONS' ? 'Notificaciones' :
                                    val.name
                        }</IonLabel>
                        <IonIcon
                          slot="end"
                          icon={val.status === 'active' ? checkmarkCircle : closeCircle}
                          color={val.status === 'active' ? 'success' : 'danger'}
                        />
                      </IonItem>
                    );
                  })}
                  {(!dataPermissions || dataPermissions.length === 0) && (
                    <IonItem className='text-center'>
                      <IonLabel>Si ya dio Permisos y no aparece la lista reinicie la app</IonLabel>
                    </IonItem>
                  )}
                </IonList>
              </IonCol>
            </IonRow>
          </IonContent>
        </IonPage >
      </>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    get_: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),
    validate_permission_: () => dispatch(UtilActions.validate_permission_()),
  }
};

export default withIonLifeCycle(connect(mapStateToProps, mapDispatchToProps)(Home));
